<template>
  <a-row :gutter="[24, 24]">
    <a-col :span="24">
      <a-card :bordered="false">
        <div class="table-page-search-wrapper">
          <a-form :form="form" layout="inline" @submit="handleSubmit">
            <a-row :gutter="12">
              <a-col :span="6">
                <a-form-item label="任务名称">
                  <a-input v-decorator="['name']"></a-input>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="截止开始">
                  <a-date-picker
                    v-decorator="['startTime']"
                    valueFormat="YYYY-MM-DD"
                    style="width:100%;min-width:100%"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="截止结束">
                  <a-date-picker
                    v-decorator="['endTime']"
                    valueFormat="YYYY-MM-DD"
                    style="width:100%;min-width:100%"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-button type="primary" icon="search" html-type="submit"
                  >查询</a-button
                >
                <a-button
                  type="default"
                  icon="reload"
                  style="margin-left:8px"
                  @click="handleReset"
                  >重置</a-button
                >
              </a-col>
            </a-row>
          </a-form>
        </div>
      </a-card>
    </a-col>

    <a-col :span="6" v-for="(item, key) in items" :key="key">
      <a-card :bordered="false" hoverable>
        <div slot="title">
          <a-row :gutter="6" type="flex" align="middle">
            <a-col :span="2">
              <a-icon type="book" />
            </a-col>
            <a-col :span="15">
              <span class="title">{{ item.workerName }}</span>
            </a-col>
            <a-col :span="5">
              <a @click="handleDetail(item)">查看详情</a>
            </a-col>
            <a-col :span="22" :offset="2">
              <!--              截止时间：{{ item.endTime.substr(0, item.endTime.indexOf(" ")) }}-->
              截止时间：{{ item.endTime }}
            </a-col>
          </a-row>
        </div>
        <a-row :gutter="6" type="flex" align="middle">
          <a-col :span="10">
            <a-row :gutter="6" type="flex" align="middle">
              <a-col :span="8">
                <img
                  src="@/assets/imgs/statistical/icon_uncommitted.png"
                  width="20"
                  height="20"
                />
              </a-col>
              <a-col :span="16">已上交：{{ item.complete }}</a-col>
            </a-row>
          </a-col>
          <a-col :span="2">
            <a-divider type="vertical" />
          </a-col>
          <a-col :span="10">
            <a-row :gutter="6" type="flex" align="middle">
              <a-col :span="6">
                <img
                  src="@/assets/imgs/statistical/icon_submitted.png"
                  width="20"
                  height="20"
                />
              </a-col>
              <a-col :span="18">未上交：{{ item.unComplete }}</a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-card>
    </a-col>
    <detail ref="detail" />
  </a-row>
</template>
<script>
import { queryPage } from "@/api/base/statistical/resource";
import detail from "./modules/detail";

export default {
  components: {
    detail
  },

  data() {
    return {
      // form
      form: this.$form.createForm(this),

      // 查询结果集合
      items: {},

      // 查询条件
      conditions: {
        // 开始时间
        stime: "",
        // 截至时间
        etime: "",
        // 请求请求页数
        page: 1,
        // 每页请求数据量，默认15条
        rows: 15,
        // 模糊查询条件
        workerName: "",
        // 排序规则
        sidx: "endTime",
        sord: "desc"
      }
    };
  },

  mounted() {
    this.loadData();
  },

  methods: {
    // 查询条件提交
    handleSubmit(e) {
      console.log(" === handleSubmit :", e);

      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);

          // 设置查询参数
          if (undefined != values.startTime) {
            this.conditions.stime = values.startTime + " 00:00:00";
          }
          if (undefined != values.endTime) {
            this.conditions.etime = values.endTime + " 23:59:59";
          }
          this.conditions.workerName = values.name;

          this.loadData();
        }
      });
    },

    // 加载统计数据
    loadData() {
      // 请求加载首页初始化数据
      queryPage(this.conditions).then(res => {
        console.log(" === statistical queryPage success: ", res);

        // 如果返回正常
        if (1 == res.resultCode) {
          this.$message.success(res.message);
          // 更新数据列表
          this.items = res.result.rows;
        } else {
          this.$message.info(res.message);
        }
      });
    },

    // 查询条件重置
    handleReset() {
      this.form.resetFields();

      // 重置请求查询条件
      this.conditions.stime = undefined;
      this.conditions.etime = undefined;
      this.conditions.workerName = undefined;
    },

    // 查看详情
    handleDetail(record) {
      this.$refs.detail.show(record);
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: 6px !important;
}
.title {
  display: inline-block;
  width: 100%;
  height: 22px;
  line-height: 28px;
  font-size: 16px;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
